import { hexToRgb } from './hexToRgb';

export function isColorBlack(color: string) {
  const [r, g, b] = hexToRgb(color);
  return r + g + b === 0;
}
